import { MainProduct } from "@/types/productTypes";
import { produce } from "immer";

import fetchDb from "../utils/customRequestFunction";

import {
   AdminSliceCreator,
   AdminStoreState,
   useAdminStore,
} from "./useAdminStore";

export interface ProductStoreState {
   allProducts: MainProduct[];
   selectedProductId: number | null;
   isLoadingProducts: boolean;
   fetchProducts: () => Promise<void>;
   addProduct: (name: string) => Promise<void>;
   updateProduct: (
      productId: number,
      field: keyof MainProduct,
      value: any
   ) => Promise<void>;
   deleteProduct: (productId: number) => Promise<void>;
   setSelectedProductId: (id: number) => void;
   selectProduct: (productId: number) => void;
}

export const createProductSlice: AdminSliceCreator<ProductStoreState> = (
   set,
   get
) => ({
   allProducts: [],
   selectedProductId: 2,
   isLoadingProducts: false,
   fetchProducts: async () => {
      set(
         produce((state: AdminStoreState) => {
            state.isLoadingProducts = true;
         })
      );
      try {
         const data: MainProduct[] = await fetchDb.get("/api/main-product");

         set(
            produce((state: AdminStoreState) => {
               state.allProducts = data;
               state.isLoadingProducts = false;
            })
         );
      } catch (err) {
         console.error("Error fetching products:", err);
         set(
            produce((state: AdminStoreState) => {
               state.isLoadingProducts = false;
            })
         );
      }
   },
   setSelectedProductId: (id) => {
      console.log("hi", id);
      set(
         produce((state: AdminStoreState) => {
            state.selectedProductId = id;
         })
      );
   },

   addProduct: async (name) => {
      const newProductData: Omit<MainProduct, "id" | "stages"> = {
         initialPrice: 0,
         title: name,
         name: name,
         relativePos: get().allProducts.length,
         hide: true,
         initialConstants: {},
      };

      try {
         const createdProduct = await fetchDb.post(
            "/api/main-product",
            newProductData
         );

         set(
            produce((state: AdminStoreState) => {
               state.allProducts.push(createdProduct);
            })
         );
         if (createdProduct.id) {
            get().selectProduct(createdProduct.id);
         }
      } catch (error) {
         console.error("Error creating product:", error);
      }
   },

   updateProduct: async (productId, field, value) => {
      set(
         produce((state: AdminStoreState) => {
            const product = state.allProducts.find((p) => p.id === productId);
            if (product) {
               (product[field] as any) = value;
               if (field === "name") {
                  product["title"] = value;
               }
            }
         })
      );
      const payload = {
         [field]: value,
      };
      if (field === "name") {
         payload["title"] = value;
      }
      try {
         await fetchDb.patch(`/api/main-product/${productId}`, payload);
      } catch (error) {
         console.error("Error updating product:", error);
      }
   },

   deleteProduct: async (productId) => {
      set(
         produce((state: AdminStoreState) => {
            state.allProducts = state.allProducts.filter(
               (product) => product.id !== productId
            );
         })
      );

      try {
         await fetchDb.delete(`/api/main-product/${productId}`);
      } catch (error) {
         console.error("Error deleting product:", error);
      }
   },
   selectProduct: (productId) => {
      useAdminStore.getState().setSelectedProductId(productId);
      useAdminStore.getState().setSelectedStageId(null);
      useAdminStore.getState().setSelectedOptionId(null);
      useAdminStore.getState().setSelectedItemId(null);
   },
});
